import { ButtonLink } from '@mfox/shared/ui/Button'
import { SiteHeader } from '@mfox/shared/ui/SiteHeader'
import './app.css'

/** Shown to every role and to signed-out visitors, so it leads home ("/"), which sends each to their own start. */
export function NotFoundPage() {
  return (
    <>
      <SiteHeader />
      <main className="not-found">
        <h1>Page not found</h1>
        <p>That link does not lead anywhere. It may be out of date.</p>
        <ButtonLink to="/">Back to home</ButtonLink>
      </main>
    </>
  )
}
